/**
 * Home page sections (sections/gr-*.liquid)
 * - Hero: thumbnails switch the featured artwork (photo, palette stripe, details, accent),
 *   and it moves on by itself every 6 seconds until the shopper picks one.
 * - Tabs: [data-gr-tabs] groups of [data-gr-tab] buttons that show one [data-gr-panel].
 */
(function () {
  'use strict';

  // How long each featured artwork stays before the hero moves on by itself
  const HERO_INTERVAL = 6000;

  function initHero(root) {
    const items = root.querySelectorAll('[data-gr-index]');
    const thumbs = root.querySelectorAll('[data-gr-hero-pick]');
    const count = root.querySelector('[data-gr-hero-count]');
    let current = 0;
    function show(i) {
      current = Number(i);
      items.forEach((el) => el.classList.toggle('is-active', el.dataset.grIndex === String(i)));
      thumbs.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.grHeroPick === String(i))));
      const accent = root.querySelector(`[data-gr-accent][data-gr-index="${i}"]`);
      if (accent) root.style.setProperty('--gr-accent', accent.dataset.grAccent);
      if (count) count.textContent = (count.dataset.grTemplate || '{current} of {total}')
        .replace('{current}', Number(i) + 1).replace('{total}', thumbs.length);
    }

    // Automatic rotation: holds while hovered or focused, while the hero is off screen or the tab is
    // hidden; stops for good once the shopper picks an artwork; off for reduced motion and in the editor.
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const inEditor = window.Shopify && window.Shopify.designMode;
    let timer = null;
    let stopped = thumbs.length < 2 || reduceMotion || inEditor;
    let hovered = false;
    let onScreen = true;
    function schedule() {
      clearTimeout(timer);
      if (stopped || hovered || !onScreen || document.hidden) return;
      timer = setTimeout(advance, HERO_INTERVAL);
    }
    function advance() {
      const next = (current + 1) % thumbs.length;
      const img = root.querySelector(`.gr-hero__slide[data-gr-index="${next}"] img`);
      const go = () => {
        if (!stopped && !hovered) show(next);
        schedule();
      };
      if (img && !img.complete) {
        img.loading = 'eager'; // load the next photo before switching, so the fade never shows a blank
        (img.decode ? img.decode() : Promise.resolve()).then(go, go);
      } else {
        go();
      }
    }

    thumbs.forEach((b) => b.addEventListener('click', () => {
      stopped = true;
      clearTimeout(timer);
      show(b.dataset.grHeroPick);
    }));
    root.addEventListener('mouseenter', () => { hovered = true; clearTimeout(timer); });
    root.addEventListener('mouseleave', () => { hovered = false; schedule(); });
    root.addEventListener('focusin', () => { hovered = true; clearTimeout(timer); });
    root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) { hovered = false; schedule(); } });
    document.addEventListener('visibilitychange', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        onScreen = entries[0].isIntersecting;
        schedule();
      }, { threshold: 0.25 }).observe(root);
    }
    schedule();
  }

  function initTabs(root) {
    const tabs = root.querySelectorAll('[data-gr-tab]');
    const panels = root.querySelectorAll('[data-gr-panel]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.dataset.grTab;
        tabs.forEach((t) => t.setAttribute('aria-pressed', String(t === tab)));
        panels.forEach((p) => { p.hidden = p.dataset.grPanel !== id; });
      });
    });
  }

  function init(scope) {
    const s = scope || document;
    s.querySelectorAll('[data-gr-hero]').forEach((el) => { if (!el.grInit) { el.grInit = true; initHero(el); } });
    s.querySelectorAll('[data-gr-tabs]').forEach((el) => { if (!el.grInit) { el.grInit = true; initTabs(el); } });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
